import React, {useEffect, useRef } from 'react';
import Aboutmain from "./WhatsApp Image 2024-11-10 at 2.51.36 PM.jpeg";
import Navbar from './Navbar';

const Services = () => {
    const aboutRef = useRef(null);

    useEffect(() => {
      const observerCallback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('shutter-effect');
          } else {
            entry.target.classList.remove('shutter-effect');
          }
        });
      };
    
      const createObserver = () => {
        const threshold = window.innerWidth < 768 ? 0.1 : 0.25;
        const observer = new IntersectionObserver(observerCallback, { threshold });
        if (aboutRef.current) {
          observer.observe(aboutRef.current);
        }
        return observer;
      };
    
      const observer = createObserver();
    
      const handleResize = () => {
        observer.disconnect();
        createObserver();
      };
    
      window.addEventListener('resize', handleResize);
    
      return () => {
        observer.disconnect();
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  return (
    <>
     <Navbar isHome={false} />
      <section ref={aboutRef} className="about-f py-3 py-md-5">
        <div className="container ">
          <div className="row gy-3 gy-md-4 gy-lg-0 align-items-lg-center">
           
            <div className="col-12 col-lg-12">
              <div className="row justify-content-xl-center">
                <div className="col-12 col-xl-12">
                  <h1 className="mb-3 text-white" >
                  Our <span className="text-danger"><span style={{textTransform:"uppercase"}}>S</span>ervices</span>
                  </h1>
                  <p className=" para mb-3 mb-xl-5 "style={{textAlign:"justify",wordSpacing:"4px"}}>
                    We possess 3 decades-long expertise to make our clients’
                    dreams come true as we are second to none in converting
                    ideas into reality with highly transparent transaction
                    techniques. From the initial Project Appraisal, Financial
                    Analysis, Designing, Management to Execution and Post
                    Completion Services or maintenance, we implement a Powerful
                    and Disciplined Approach tailored to our Projects’ needs.
                  </p>
                 
                  <div className="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">
                        Conversion of Raw Land into Residential, Commercial
                        &amp; Industrial projects.
                      </p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">
                        We deliver services beyond expectations Real Estate
                        Project Marketing, Sales &amp; Management.
                      </p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">Land Acquisition.</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">
                        Designing, Town Planning &amp; Engineering Services.
                      </p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                       fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">
                        Creative ideas &amp; Media Solutions.
                      </p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">Responsive Design Campaigns.</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0">
                        Development &amp; Construction.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-12 about-main" >
              <img
                className="img-fluid rounded"
                loading="lazy"
                src={Aboutmain}
                alt="About 2"
              />
            </div>
          </div>
        </div>
       
      </section>
    </>
  )
}

export default Services
